
    import '/Users/lijixiang/Work/power-design/site/docs/power-design/shortcut-selector.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-power-design-shortcut-selector-demo-shortcut-selector"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/Users/lijixiang/Work/power-design/site/docs/power-design/shortcut-selector.md?type=demo')
};